export const PWF_ACTIVATION_STATUS = {
  NONE: 0,
  PENDING: 1,
  ACTIVE: 2,
  INACTIVE: 3,
  ACCEPTED: 4
};

export const PWF_CREATED_FROM = {
  WEB: 1,
  API: 2
};

// v2 API
export const PWF_CREATED_FROM_TYPE = {
  DASHBOARD: "DASHBOARD",
  API: "API"
};

export const PWF_STEP = {
  BILL_INFO: 1,
  USER_INFO: 2,
  CONFIRMATION: 3
};

// v2 API
export const PWF_STEP_TYPE = {
  /**
   * Step 1
   */
  FLIP_CHECKOUT: "FLIP Checkout",
  /**
   * Step 2
   */
  FLIP_CHECKOUT_SEAMLESS: "FLIP Checkout Seamless",
  /**
   * Step 3
   */
  DIRECT_API: "FLIP Direct API"
};

export const PWF_PAYMENT_STATUS = {
  NEW_PAYMENT: 0,
  PENDING_GROUP: 1,
  READY_GROUP: 2,
  PENDING: 10,
  WRONG_ACCOUNT: 22,
  IN_PROCESS_GROUP: 3,
  SUCCESS: 40,
  CANCELLED: 50,
  CANCELLED_BY_SYSTEM: 51,
  CANCELLED_BY_ADMIN: 52,
  FAILED: 60
};

/** Mirrors the backend's DetailedTransactionStatus IsValid set in b2b-accept-payments-service. */
export const PWF_PAYMENT_DETAILED_STATUS = {
  /** Transaction is expired. */
  EXPIRED: "expired",
  /** Transaction is waiting to be processed by the system. */
  PROCESSOR_UPDATE_PENDING: "processor_update_pending",
  /** Transaction is waiting for customer action. */
  AWAITING_CUSTOMER_ACTION: "awaiting_customer_action",
  /** Transaction is cancelled by user */
  CANCELLED_BY_USER: "cancelled_by_user",
  /** Transaction is cancelled by the system (e.g. the payment processor). */
  CANCELLED_BY_SYSTEM: "cancelled_by_system",
  /** Transaction is completed. */
  COMPLETED: "completed",
  /** Transaction has failed. */
  FAILED: "failed",
  /** Transaction is refunded. */
  REFUNDED: "refunded",
  /** Transaction timed out. */
  TIMEOUT: "timeout"
};

export const PWF_BILL_STATUS = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  USED_SINGLE: "USED_SINGLE",
  USED_MULTIPLE: "USED_MULTIPLE"
};

export const PWF_BILL_TYPE = {
  USED_SINGLE: 1,
  USED_MULTIPLE: 2
};

export const REPORT_STATUS_PROCESS = 1;

export const DEFAULT_INTERVAL_RELOAD = 15000;

export const SENDER_BANK_TYPE = {
  VA: "virtual_account",
  BA: "bank_account"
};

export const PWF_VA = [
  { key: "bni_va", logo: "bni", name: "BNI VA", type: SENDER_BANK_TYPE.VA },
  { key: "permata_va", logo: "permata", name: "Permata VA", type: SENDER_BANK_TYPE.VA },
  { key: "bri_va", logo: "bri", name: "BRI VA", type: SENDER_BANK_TYPE.VA }
];

export const PWF_SENDER_BANK = [
  { key: "bca", logo: "bca", name: "BCA", type: SENDER_BANK_TYPE.BA },
  { key: "bri", logo: "bri", name: "BRI", type: SENDER_BANK_TYPE.BA },
  { key: "mandiri", logo: "mandiri", name: "Mandiri", type: SENDER_BANK_TYPE.BA },
  { key: "bni", logo: "bni", name: "BNI", type: SENDER_BANK_TYPE.BA },
  {
    key: "tabungan_pensiunan_nasional",
    logo: "tabungan_pensiunan_nasional",
    name: "BTPN/Jenius/BTPN Wow!",
    type: SENDER_BANK_TYPE.BA
  },
  { key: "bsm", logo: "bsi", name: "BSI (Bank Syariah Indonesia)", type: SENDER_BANK_TYPE.BA },
  { key: "cimb", logo: "cimb", name: "CIMB/CIMB Syariah", type: SENDER_BANK_TYPE.BA },
  { key: "muamalat", logo: "muamalat", name: "Muamalat", type: SENDER_BANK_TYPE.BA },
  { key: "permata", logo: "permata", name: "Permata/Permata Syariah", type: SENDER_BANK_TYPE.BA },
  { key: "dbs", logo: "dbs", name: "Digibank/DBS", type: SENDER_BANK_TYPE.BA }
];
